import { useEffect, useState } from "react";
import { Layout } from "../components/Layout";
import { HeroSection } from "../components/HeroSection";
import { CategoryGrid } from "../components/CategoryGrid";
import { WhyTFM } from "../components/WhyTFM";
import { ProductsForEverySpace } from "../components/ProductsForEverySpace";
import { WholesaleEnquirySection } from "../components/WholesaleEnquirySection";
import { ProductCard } from "../components/ProductCard";
import { Link } from "react-router-dom";
import { ArrowRight, Star } from "lucide-react";
import api from "../lib/api";

export default function HomePage() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [featured, setFeatured] = useState([]);
  const [palette, setPalette] = useState({});

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
    api.get("/products").then((r) => setProducts(r.data.slice(0, 8))).catch(() => {});
    api.get("/products", { params: { featured: true } }).then((r) => setFeatured(r.data)).catch(() => {});
    api.get("/colours").then((r) => {
      const p = {}; r.data.forEach((c) => (p[c.name] = c.hex)); setPalette(p);
    }).catch(() => {});
  }, []);

  return (
    <Layout>
      <HeroSection />
      <CategoryGrid categories={categories} />

      {featured.length > 0 && (
        <section className="bg-white py-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6">
            <div className="mb-8 flex items-end justify-between">
              <div>
                <span className="inline-flex items-center gap-1.5 font-spec text-xs font-semibold uppercase tracking-[0.2em] text-[#10B981]">
                  <Star className="h-3.5 w-3.5 fill-[#10B981]" /> Bestsellers
                </span>
                <h2 className="mt-2 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
                  Our Top Products
                </h2>
              </div>
              <Link to="/catalogue" className="hidden items-center gap-1 text-sm font-semibold text-[#059669] hover:gap-2 sm:flex">
                View all <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {featured.slice(0, 4).map((p) => <ProductCard key={p.id} product={p} palette={palette} minimal />)}
            </div>
          </div>
        </section>
      )}

      <WhyTFM />

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="mb-8 flex items-end justify-between">
          <div>
            <span className="font-spec text-xs font-semibold uppercase tracking-[0.2em] text-[#10B981]">Catalogue</span>
            <h2 className="mt-2 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
              Featured Products
            </h2>
          </div>
          <Link to="/catalogue" className="hidden items-center gap-1 text-sm font-semibold text-[#059669] hover:gap-2 sm:flex">
            View all <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {products.map((p) => <ProductCard key={p.id} product={p} palette={palette} minimal />)}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link to="/catalogue" className="inline-flex items-center gap-1 text-sm font-semibold text-[#059669]">
            View all products <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>

      <ProductsForEverySpace />
      <WholesaleEnquirySection />
    </Layout>
  );
}
